export const GA_MEASUREMENT_ID = "G-B2DRSVXRYZ";

export function isAnalyticsAvailable() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

export function trackPageView({ pathname, search = "", hash = "" }) {
  if (!isAnalyticsAvailable()) return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: `${window.location.origin}${pathname}${search}${hash}`,
    page_path: `${pathname}${search}${hash}`,
  });
}

/* Il consenso GA e' gestito dal banner Iubenda (Google Consent Mode automatico);
   il callback in index.html forza ad_storage/ad_user_data/ad_personalization a denied
   perche' il sito non usa pubblicita'. */

/* Evento conversione: inviato quando il modulo contatti viene inviato con successo.
   In GA4 va marcato come "evento chiave" per vedere i lead per canale. */
export function trackGenerateLead(subject) {
  if (!isAnalyticsAvailable()) return;
  window.gtag("event", "generate_lead", {
    event_category: "contact",
    form_name: "contact_form",
    ...(subject ? { lead_subject: subject } : {}),
  });
}
